
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doDelete: { api: 'M0110CenterService.M20101_doDelete' },
    doBrowse: { api: 'M0110CenterService.M20101_doBrowse' },
  },
}

const module = {
  state: {
    PageConst,
  },
  getters: {},
  mutations: {},
  actions: {
    async M20101_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M20101_doAdd({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0110CenterService.M20101_doAdd', input: payload },
        ]
      })
    },
    async M20101_getEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0110CenterService.M20101_getEdit', input: payload },
        ]
      }).then((res) => {
        return res[0].output;
      })
    },
    async M20101_doEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0110CenterService.M20101_doEdit', input: payload },
        ]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
